import axios from 'axios';

const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';

export default axios.create({
	baseURL: `https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/`
	// baseURL: "/mockData/"
});



// WEBPACK FOOTER //
// ./src/api/horizon.js